<template>
  <div class="p-grid">
    <div class="p-col-12 p-d-flex p-justify-between">
      <div style="width: 300px">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="pi pi-search"></i>
          </span>
          <InputText v-model="searchString" placeholder="ระบุคำค้น"></InputText>
        </div>
      </div>
      <div>
        <Button
          label="Upload"
          icon="pi pi-upload"
          class="p-ml-2"
          @click="isUploadPopup = true"
        ></Button>
        <Button
          label="เพิ่มผู้เข้าร่วมอบรม"
          icon="pi pi-plus"
          class="p-ml-2 p-button-success"
          @click="onNewTrainingAttendance"
        ></Button>
      </div>
    </div>
    <div class="p-col-12">
      <DataTable
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 20, 50]"
        :value="filteredTrainingAttendance"
        class="p-datatable-sm"
        ref="trainingAttendanceTable"
        dataKey="employeeId"
      >
        <template #empty>ไม่พบข้อมูล</template>
        <Column
          field="employeeId"
          header="รหัส"
          :sortable="true"
          headerStyle="width:8rem"
          bodyStyle="width:8rem"
        >
        </Column>
        <Column header="ชื่อ-สกุล">
          <template #body="props">
            {{ props.data.employee.prename }}{{ props.data.employee.name }}
            {{ props.data.employee.surname }}</template
          >
        </Column>
        <Column
          field="employee.level"
          header="ระดับ"
          :sortable="true"
          headerStyle="width:6rem"
          bodyStyle="width:6rem"
        >
        </Column>
        <Column field="employee.position" header="ตำแหน่ง" :sortable="true">
        </Column>
        <Column
          field="employee.yearOfService"
          header="อายุงาน"
          :sortable="true"
          headerStyle="width:8rem"
          bodyStyle="width:8rem"
        >
        </Column>
        <Column
          field="employee.departmentDescription"
          header="แผนก"
          :sortable="true"
        >
        </Column>
        <Column
          field="employee.divisionDescription"
          header="ฝ่าย"
          :sortable="true"
        >
        </Column>
        <Column header="ประเมินการอบรม" :sortable="true">
          <template #body="employee">
            <AssessmentBadge :attendance="employee.data" />
            <!-- <Button
              class="p-button-success p-mr-2 p-button-outlined"
              icon="pi pi-check"
              v-if="employee.data.assessmentData"
              @click="onshowInternalForm(employee.data)"
            ></Button>
            <Button
              class="p-button-danger p-mr-2 p-button-outlined"
              icon="pi pi-circle-off"
              v-if="!employee.data.assessmentData"
              disabled="false"
            ></Button>
            <Button
              class="p-button-success p-mr-2 p-button-outlined"
              icon="pi pi-check"
              v-if="employee.data.approveOn"
              @click="onshowInternalForm(employee.data)"
            ></Button>
            <Button
              class="p-button-danger p-mr-2 p-button-outlined"
              icon="pi pi-circle-off"
              v-if="!employee.data.approveOn"
              disabled="false"
            ></Button> -->
          </template>
        </Column>
        <Column headerStyle="width: 8rem" bodyStyle="width: 8rem">
          <template #body="props">
            <Button
              class="p-button-rounded p-button-success p-mr-2"
              icon="pi pi-pencil"
              @click="onEditTrainingAttendance(props.data)"
              :disabled="isReadonly(props.data)"
            ></Button>
            <Button
              class="p-button-rounded p-button-danger"
              icon="pi pi-trash"
              @click="onDeleteTrainingAttendance(props.data)"
              :disabled="isReadonly(props.data)"
            ></Button>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
  <Dialog
    header="เพิ่มผู้เข้าร่วมอบรม"
    v-model:visible="showDialog"
    :modal="true"
    class="p-fluid"
  >
    <div class="p-grid">
      <div class="p-col-12" v-if="errors && errors.length > 0">
        <Message severity="error" v-for="error in errors" :key="error">{{
          error
        }}</Message>
      </div>
      <div class="p-col-12">
        <small
          >ระบุรหัสพนักงานผู้เข้าร่วมอบรม โดยสามารถ copy จาก excel
          มาแปะได้โดยบรรทัดละ 1 ท่าน</small
        >
      </div>

      <div class="p-col-12">
        <span class="p-float-label">
          <Textarea
            v-model="addedUsers"
            rows="5"
            cols="10"
            :class="{ 'p-invalid': v$.addedUsers.$error }"
          ></Textarea>
        </span>
        <small
          class="p-error"
          v-for="message in v$.addedUsers.$errors"
          :key="message.$uid"
          >{{ message.$message }}</small
        >
      </div>
    </div>
    <template #footer>
      <Button
        icon="pi pi-check"
        label="ยืนยัน"
        class="p-button-success"
        @click="onSaveTrainingAttendance"
      ></Button>
      <Button
        icon="pi pi-times"
        label="ยกเลิก"
        class="p-button-danger p-ml-2"
        @click="onHideDialog"
      ></Button>
    </template>
    <!-- TODO: Addlogic here for save list of users. -->

    <!-- <div class="p-field">
      <label for="inputUser" class="p-text-bold">พนักงาน</label>
      <div class="p-field p-mt-2">
        <InputUser id="inputUser" v-model="selectedUser"></InputUser>
      </div>
    </div>
    <template #footer>
      <Button
        icon="pi pi-check"
        label="ยืนยัน"
        class="p-button-success"
        @click="onSaveTrainingAttendance"
      ></Button>
      <Button
        icon="pi pi-times"
        label="ยกเลิก"
        class="p-button-danger p-ml-2"
        @click="onHideDialog"
      ></Button>
    </template> -->
  </Dialog>
  <Dialog
    v-model:visible="popupDeleteDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="trainingAttendance"
        >กรุณายืนยันเพื่อทำการลบข้อมูลผู้เข้าร่วมอบรม
        <b>{{ trainingAttendance.employeeId }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="popupDeleteDialog = false"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        class="p-button-text"
        @click="handleDeleteTrainingAttendance"
      />
    </template>
  </Dialog>
  <Dialog
    v-model:visible="isUploadPopup"
    modal
    :dismissible="true"
    header="ทำการ upload รายชื่อผู้เข้าร่วมอบรม"
  >
    <div class="p-grid">
      <div class="p-col-12"></div>
      <div class="p-col-12">
        <Button
          icon="pi pi-ellipsis-v"
          label="เลือกไฟล์ Excel"
          @click="onUploadAttendance"
        ></Button>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType, watch } from "vue";
import { usePlugin } from "@/plugins";
import {
  TrainingAttendance,
  GetTrainingAttendanceResponse,
  TrainingAttendanceUpdateDto,
  TrainingDocument,
  TrainingTypeEnum,
  DeleteTrainingAttendanceRequest,
  UpsertTrainingAttendanceResponse,
} from "@/types";
import Fuse from "fuse.js";
import { clone } from "ramda";
// import InputUser from "@/components/InputUser.vue";
import useUpload from "@/upload";
import AssessmentBadge from "@/components/AssessmentBadge.vue";
import { useConfirm } from "primevue/useconfirm";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
export default defineComponent({
  name: "TrainingAttendanceList",
  components: { AssessmentBadge },
  props: {
    items: Array as PropType<TrainingAttendance[]>,
    document: {} as PropType<TrainingDocument>,
    disabled: {
      type: Boolean,
    },
  },
  setup(props) {
    const {
      success,
      error,
      axios,
      setLoading,
      information,
      onRouterPush,
    } = usePlugin();
    const { showUpload } = useUpload();
    const trainingAttendances = ref<TrainingAttendance[]>([]);
    const trainingAttendance = ref<TrainingAttendance>(
      {} as TrainingAttendance
    );
    const selectedUser = ref("");
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const popupConfirmDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const isUploadPopup = ref(false);
    const confirm = useConfirm();
    const editUser = ref(false);
    const oldEmployeeId = ref("");
    const errors = ref<string[]>([]);
    const isShowInternalAssessment = computed(() => {
      return props.document?.trainingType === TrainingTypeEnum.Internal;
    });
    const isShowExternalAssessment = computed(() => {
      return props.document?.trainingType === TrainingTypeEnum.External;
    });

    const filteredTrainingAttendance = computed(() => {
      if (!searchString.value) return trainingAttendances.value;
      const fuse = new Fuse(trainingAttendances.value, {
        keys: ["employeeId", "User.fullName", "User.position"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const addedUsers = ref("");
    const validateInput = (value: any) => {
      if (typeof value !== "string") return false;
      if (value.split("\n").filter((x) => x.length > 5).length > 0)
        return false;
      return true;
    };
    const rules = {
      addedUsers: {
        required,
        validateInput: helpers.withMessage(
          "กรุณาระบุ Employee ID บรรทัดละ 1 Employee ID ความยาวบรรทัดละไม่เกิน 5 ตัวอักษร",
          validateInput
        ),
      },
    };
    const v$ = useVuelidate(
      rules,
      {
        addedUsers,
      },
      { $scope: false }
    );

    const onSaveTrainingAttendance = async () => {
      v$.value.$reset();
      v$.value.$touch();
      if ((await v$.value.$validate()) === false) return;

      submitted.value = true;
      setLoading(true);
      // if (oldEmployeeId.value !== selectedUser.value) {
      //   let trainingAttendanceUpdateDto = {
      //     trainingAttendancesUpdate: [
      //       {
      //         trainingDocumentId: props.document?.id,
      //         employeeId: selectedUser.value,
      //       } as TrainingAttendance,
      //     ],
      //   } as TrainingAttendanceUpdateDto;

      //   if (oldEmployeeId.value !== "") {
      //     trainingAttendanceUpdateDto.trainingAttendancesDelete = [
      //       {
      //         trainingDocumentId: props.document?.id,
      //         employeeId: oldEmployeeId.value,
      //       } as TrainingAttendance,
      //     ];
      //   }

      const trainingAttendanceUpdateDto: TrainingAttendanceUpdateDto = {
        trainingAttendancesDelete: null,
        trainingAttendancesUpdate: addedUsers.value
          .split("\n")
          .filter((x) => x)
          .map(
            (x) =>
              ({
                trainingDocumentId: props.document?.id ?? "",
                employeeId: x,
              } as TrainingAttendance)
          ),
      };

      try {
        const result = await axios.post<UpsertTrainingAttendanceResponse>(
          "api/v1/services/trainingAttendance/upsert",
          trainingAttendanceUpdateDto
        );

        if (result.data.errors && result.data.errors.length > 0) {
          errors.value = result.data.errors;
          return;
        }

        success("บันทึกข้อมูลสำเร็จแล้ว");
        showDialog.value = false;
        await loadTrainingAttendances();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
    };

    const onNewTrainingAttendance = async () => {
      trainingAttendance.value = {} as TrainingAttendance;
      selectedUser.value = "";
      showDialog.value = true;
      submitted.value = false;
      editUser.value = false;
      oldEmployeeId.value = "";
    };

    const onEditTrainingAttendance = async (source: TrainingAttendance) => {
      trainingAttendance.value = {} as TrainingAttendance;
      selectedUser.value = "";
      showDialog.value = true;
      submitted.value = false;
      editUser.value = true;
      oldEmployeeId.value = clone(source.employeeId ?? "N/A");
    };

    const onDeleteTrainingAttendance = async (source: TrainingAttendance) => {
      trainingAttendance.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const loadTrainingAttendances = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetTrainingAttendanceResponse>(
          `api/v1/services/trainingAttendance/${props.document?.id}`
        );
        trainingAttendances.value = result.data.trainingAttendances ?? [];
        // trainingAttendances.value = [] as TrainingAttendance[];
        // if (result.data.trainingAttendances) {
        //   for (let i = 0; i < result.data.trainingAttendances.length; i++) {
        //     const trainingAttendance = result.data.trainingAttendances[i];

        //     // const user = await searchUser(
        //     //   trainingAttendance?.employeeId ?? "N/A"
        //     // );
        //     // if (user && user.length > 0) {
        //     //   const trainingAttendanceDto = ref<TrainingAttendance>({
        //     //     trainingDocumentId: trainingAttendance.trainingDocumentId,
        //     //     employeeId: trainingAttendance.employeeId,
        //     //   } as TrainingAttendance);
        //     //   trainingAttendances.value.push(trainingAttendanceDto.value);
        //     // }
        //   }
        // }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const fileName = ref({} as FileList);

    const onUploadAttendance = async () => {
      showUpload(async (files: FileList | null) => {
        if (files && !files.length) {
          error("กรุณาระบุไฟล์ที่ต้องการ upload");
        }
        // handleUploadAttendance(files![0]);
        confirm.require({
          message: "ข้อมูลทั้งหมดจะถูกลบและ สร้างใหม่ตามข้อมูลใน Excel",
          header: "ยืนยัน upload ข้อมูล",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", files![0]);
            formData.append("trainingDocumentNo", props.document?.id ?? "");
            try {
              const result = await axios.post(
                "api/v1/services/attendance/upload",
                formData,
                {
                  timeout: 120000,
                }
              );
              success("upload ข้อมูลเรียบร้อยแล้ว");
              await loadTrainingAttendances();
              isUploadPopup.value = false;
            } catch (e) {
              error(e);
            } finally {
              setLoading(false);
            }
          },
          reject: () => {
            information("การ upload ถูกยกเลิกแล้ว");
            isUploadPopup.value = false;
          },
        });
      });
    };

    const handleUploadAttendance = async (file: any) => {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const result = await axios.post(
          "api/v1/services/attendance/upload",
          formData,
          {
            timeout: 120000,
          }
        );
        success("upload ข้อมูลเรียบร้อยแล้ว");
        await loadTrainingAttendances();
        isUploadPopup.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      popupConfirmDialog.value = false;
    };

    watch(
      () => props.items,
      () => (trainingAttendances.value = clone(props.items ?? []))
    );

    const isReadonly = (trainingAttendance: TrainingAttendance) => {
      if (
        trainingAttendance.assessments !== null &&
        (trainingAttendance.assessments?.length ?? 0) > 0
      ) {
        if (
          trainingAttendance.assessments.findIndex((x) => !!x.assessmentData) >=
          0
        ) {
          return true;
        }
      }
      return false;
    };

    const handleDeleteTrainingAttendance = async () => {
      setLoading(true);
      try {
        const result = await axios.delete(
          "api/v1/services/trainingAttendance/delete",
          {
            data: {
              trainingAttendances: [
                {
                  trainingDocumentId:
                    trainingAttendance.value.trainingDocumentId,
                  employeeId: trainingAttendance.value.employeeId,
                },
              ],
            } as DeleteTrainingAttendanceRequest,
          }
        );
        await loadTrainingAttendances();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };
    return {
      onNewTrainingAttendance,
      onEditTrainingAttendance,
      onDeleteTrainingAttendance,
      searchString,
      filteredTrainingAttendance,
      trainingAttendance,
      submitted,
      onHideDialog,
      showDialog,
      onSaveTrainingAttendance,
      popupDeleteDialog,
      handleDeleteTrainingAttendance,
      trainingAttendances,
      onUploadAttendance,
      isUploadPopup,
      popupConfirmDialog,
      TrainingTypeEnum,
      isShowInternalAssessment,
      isShowExternalAssessment,
      selectedUser,
      isReadonly,
      addedUsers,
      v$,
      errors,
    };
  },
});
</script>

<style></style>
